import { render } from "./UmsSend.vue?vue&type=template&id=6c806f4e&scoped=true"
import script from "./UmsSend.vue?vue&type=script&lang=js"
export * from "./UmsSend.vue?vue&type=script&lang=js"

import "./UmsSend.vue?vue&type=style&index=0&id=6c806f4e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c806f4e"]])

export default __exports__